var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29,
    rx: 14.5,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2071 15.2071C21.5976 14.8166 21.5976 14.1834 21.2071 13.7929L14.8431 7.42893C14.4526 7.03841 13.8195 7.03841 13.4289 7.42893C13.0384 7.81946 13.0384 8.45262 13.4289 8.84315L19.0858 14.5L13.4289 20.1569C13.0384 20.5474 13.0384 21.1805 13.4289 21.5711C13.8195 21.9616 14.4526 21.9616 14.8431 21.5711L21.2071 15.2071ZM9.5 15.5L20.5 15.5L20.5 13.5L9.5 13.5L9.5 15.5Z",
    fill: "#0069CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/Button-Arrow.d829e9b84da275e59cd7bc51fa31c29e.svg";
export { ForwardRef as ReactComponent };